import { Flex } from '@grupoboticario/flora-react';
import styled from 'styled-components';
import Text from 'styles/typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;

  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
`;

export const Title = styled(Text)`
  font-size: 20px;
  line-height: 74px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.mainDark};
  margin-top: 0.4rem;
  margin-bottom: 0.7rem;
`;

export const ReportClaim = styled(Flex)`
  --swiper-theme-color: #575757;

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.shape};

  padding: 13px;

  height: 400px;

  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const SwiperWrapper = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;

  .swiper {
    flex: 1;
    height: 100%;
  }

  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 26px;
    color: ${({ theme }) => theme.colors.main};
    flex-direction: column;
  }

  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    cursor: pointer;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;

    svg {
      width: 22px;
      height: 22px;
    }

    &.swiper-button-disabled {
      opacity: 0.35;
      pointer-events: none;
    }
  }

  .swiper-button-prev {
    left: 0;
  }

  .swiper-button-next {
    right: 0;
  }

  .swiper-pagination {
    bottom: 5px;
  }

  .swiper-pagination-bullet + .swiper-pagination-bullet {
    margin-left: 6px;
  }
`;

interface StepProps {
  size?: 'normal' | 'large';
}

export const StepWrapper = styled.div<StepProps>`
  p {
    line-height: 18px;
    font-size: 16px;
  }
  main {
    margin-top: 13px;
    display: flex;
    justify-content: space-around;

    svg {
      max-width: 160px;
    }
    p {
      font-size: ${({ size }) => (size === 'large' ? '22px' : '12px')};
      line-height: ${({ size }) => (size === 'large' ? '22px' : '16px')};
      width: 50%;
    }
  }
  span.upper {
    text-transform: uppercase;
  }
  span.tipsBlock {
    display: block;
    font-weight: 700;
  }
  span.tips {
    font-weight: 700;
  }
  .centerTips {
    text-align: center;
  }

  @media (max-width: 1110px) {
    main img,
    svg {
      display: inherit;
    }
  }

  @media (max-width: 460px) {
    main {
      img,
      svg {
        display: none;
      }
      p {
        width: 100%;
      }
    }
  }

  @media (min-width: 1111px) and (max-width: 1200px) {
    main {
      img,
      svg {
        display: none;
      }
      p {
        width: 100%;
      }
    }
  }
`;

export const Slide2Ul = styled.ul`
  margin-left: 30px;
  list-style: disc;

  li {
    list-style: disc;

    font-size: 13px;
    font-weight: 600;
    line-height: 16px;
  }
`;
